(function ( $ ) {
    (function () {
        $('.login-form').submit(function (e) {
            e.preventDefault()
            let email = $(this).find('[name="email"]').val();
            let phoneNumber = $(this).find('[name="phone"]').val();
            let password = $(this).find('[name="password"]').val();
            let token = $('meta[name="csrf-token"]').attr('content');
            let $errors = $(this).find(".login-error");
            $errors.html('');

            $(".login-form .spinner-for-btn").css('display','inline-block');
            $(".login-form  input[type='submit']").prop('disabled', true);

            axios
                .post(`/ajax/login`, {
                    email: email,
                    phoneNumber: phoneNumber,
                    password: password,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    let pathArray = window.location.pathname.split('/');
                    var lang = pathArray[1];

                    if (lang === "ua") {
                        window.location.replace("/ua/account");
                    } else {
                        window.location.replace("/account");
                    }
                })
                .catch(error => {
                    console.log(error.response.data);
                    if (error.response.status === 503) {
                        $errors.html(error.response.data.errors);
                    }
                    if (error.response.data.login_via_sms) {
                        $('.popup-login').fadeOut();
                        setTimeout(function () {
                            $('#register_confirm_form_on_login').fadeIn();
                            $('#register_confirm_form_on_login [name="phoneNumber"]').val(phoneNumber);
                        }, 500);

                    } else {
                        if (error.response.data.errors.length) {
                            $errors.html(error.response.data.errors.join(", "));
                        }
                    }
                })
                .then(() => {
                    $(".login-form .spinner-for-btn").hide();
                    $(".login-form  input[type='submit']").prop('disabled', false);
                });
        });
    }());


}( jQuery ));
